export default __webpack_public_path__ + "static/media/56.678bc18f.gif";